<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="searchArea">
        <a-select v-model:value="inputs.clubId" placeholder="门店" style="width: 275px;">
          <a-select-option v-for="item in clubList" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>

        <a-date-picker v-model:value="inputs.date" @change="changeDate" placeholder="日期" />
        <a-button type="primary" shape="circle" @click="search('')">
          <template #icon>
            <SearchOutlined />
          </template>
        </a-button>
        <a-button style="margin-left: 10px" type="primary" @click="showModal()">
          <template #icon>
            <PlusOutlined />
          </template>
          新建预约
        </a-button>
      </div>
      <div class="statusList">
        <div v-for="item in statusList" :class="item.focus ? 'focus status' : 'status'"
          :style="{ 'background-color': statusColor[item.name] }" @click="selectStatus(item)">
          {{ item.name }}
        </div>
      </div>
      <a-table class="ant-table-striped theme-table" :columns="columns" :data-source="data"
        :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)" bordered rowKey="period"
        :pagination="false" :scroll="scrollConfig">
        <template v-for="col in employeeList" #[col.id]="{ text, record }" :key="col">
          <div v-if="record?.appointmentMap && record?.appointmentMap[col.id]">
            <div v-for="item in record?.appointmentMap[col.id]">
              <div @click="showDetail(item)"
                :class="'table_status ' + (item.appointedByCustomer ? 'customer ' : '') + (item?.customer?.sdmSource ? 'club' : '')"
                :style="{
                  'background-color': statusColor[item.tcmStatus]
                }" v-if="currentStatus == '全部' || item.tcmStatus == currentStatus">
                {{ item.customerName }}
              </div>

            </div>
          </div>
        </template>
      </a-table>

    </div>

  </div>
  <addAppointment v-model="visible" :date="inputs.date" :clubList="clubList" :clubId="inputs.clubId" />
  <appointmentDetail v-model="visible2" :uuid="detailUuid" />
</template>

<script>
import {
  SearchOutlined,
  PlusOutlined,
  DownloadOutlined,
  CheckCircleFilled,
  WarningFilled,
  FormOutlined
} from "@ant-design/icons-vue";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import { Search, ClubList } from "/src/api/businessManage/appointment.js";
import addAppointment from "/src/components/businessManage/addAppointment.vue";
import moment from "moment";
import appointmentDetail from "/src/components/businessManage/appointmentDetail.vue";

export default {
  components: {
    SearchOutlined,
    PlusOutlined,
    DownloadOutlined,
    locale,
    CheckCircleFilled,
    WarningFilled,
    FormOutlined,
    addAppointment,
    appointmentDetail
  },
  name: "单日预约管理",
  data() {
    return {
      id: undefined,
      selectedRow: {},
      statusList: [
        {
          name: '全部',
          focus: true,
        }, {
          name: '未开始',
          focus: false,
        }, {
          name: '候诊中',
          focus: false,
        }, {
          name: '看诊中',
          focus: false,
        }, {
          name: '看诊完成',
          focus: false,
        }
      ],
      statusColor: {
        "全部": "#909399",
        "未开始": "#E6A23C",
        "候诊中": "#409EFF",
        "看诊中": "#F56C6C",
        "看诊完成": "#67C23A",
        "已过期": "#999999",
      },
      visible: false,
      visible2: false,
      currentStatus: "全部",
      inputs: {
        date: undefined,
        clubId: undefined, // 这里修改为 clubId，保持前后端及绑定的统一
      },
      clubList: [],
      labelCol: {
        span: 6,
      },
      employeeList: [],
      wrapperCol: {
        span: 14,
      },
      columns: [],
      data: [],
      detailUuid: null,

      // doExcel: doExcel
    };
  },
  created() { },
  mounted() {
    this.init()
  },
  activated() {
    if (localStorage.getItem("refrashProject") == "true") {
      // this.search(1);
    }
    localStorage.setItem("refrashProject", false);
  },
  computed: {
    // 高度：根据屏幕高度减上方搜索区、状态栏及边距，再往下取整到 80 的倍数
    tableHeight() {
      const used = 220; // 搜索区 + 状态栏 + 上下边距预留
      const h = Math.floor((window.innerHeight - used) / 80) * 65;
      return Math.max(h, 200);
    },
    scrollConfig() {
      console.log("this.tableHeight", this.tableHeight);
      return { x: 500, y: this.tableHeight };
    }
  },
  methods: {
    async init() {
      await this.getClubList()
      let { date, clubId } = this.$route.query;
      if (date) {
        this.inputs.date = date;
        this.inputs.clubId = parseInt(clubId);
        this.$route.query.date = undefined;
        this.$route.query.clubId = undefined;
        this.search();
      } else {
        this.inputs.date = moment();
        if (this.inputs.clubId) {
          this.search();
        }
      }
    },
    showModal() {
      this.visible = true
    },
    async getClubList() {
      let res = await ClubList({ clubCategory: "门诊部", checked: true })
      if (res.errCode == 0) {
        // 1. 数据映射
        this.clubList = res.data.map(item => {
          return {
            ...item,
            id: item.id || item.clubId,
            name: item.name || item.clubName,
            clubId: item.clubId || item.id,
            clubName: item.clubName || item.name
          }
        });

        // 2. 添加默认选中逻辑：如果只有一个门店且当前没有选中的 clubId，则默认选中
        if (this.clubList.length === 1 && !this.inputs.clubId) {
          this.inputs.clubId = this.clubList[0].id;
        }
      }
    },
    changeDate(date, dateString) {
      this.inputs.date = date;
    },
    resetForm() {
      this.inputs = {
        name: undefined,
        gender: undefined,
        isStandard: undefined,
      }
    },
    tabsName(tabName) {
      this.$store.commit("changePage", { name: tabName.name, query: tabName.query });
    },
    async search(pagination) {
      let _this = this;

      if (!this.inputs.clubId) {
        this.$message.error("请选择门店", function () { });
        return
      }
      if (!this.inputs.date) {
        this.$message.error("请选择日期", function () { });
        return
      }
      let date;
      if (this.inputs.date) {
        //判断date是string还是date对象
        if (typeof this.inputs.date === "string") {
          date = this.inputs.date
        } else {
          date = this.inputs.date.format("YYYY-MM-DD")
        }
      } else {
        date = undefined
      }
      let params = {
        clubId: this.inputs.clubId,
        onlyCurrentUser: false,
        pageSize: 1000,
        date,
      };
      let res = await Search(params)
      if (res.errCode == 0) {
        let records = res.data.records || [];

        // 1. 从预约记录中提取医生列表（去重），作为表格列
        let doctorMap = {};
        records.forEach(item => {
          if (item.doctorId && !doctorMap[item.doctorId]) {
            doctorMap[item.doctorId] = {
              id: item.doctorId,
              name: item.doctorName
            };
          }
        });
        this.employeeList = Object.values(doctorMap);

        // 2. 构建表格列：第一列为预约时间，其后每个医生一列
        this.columns = [{
          title: "预约时间",
          dataIndex: "period",
          width: "100px",
          fixed: "left",
          slots: {
            customRender: "period",
          }
        }];
        this.employeeList.forEach(item => {
          this.columns.push({
            title: item.name,
            dataIndex: item.id,
            width: "150px",
            slots: {
              customRender: item.id
            }
          })
        });

        // 3. 将扁平记录按时段分组，生成 appointmentMap[doctorId] 结构
        let periodMap = {};
        records.forEach(item => {
          if (!periodMap[item.period]) {
            periodMap[item.period] = {
              period: item.period,
              appointmentMap: {}
            };
          }
          if (!periodMap[item.period].appointmentMap[item.doctorId]) {
            periodMap[item.period].appointmentMap[item.doctorId] = [];
          }
          periodMap[item.period].appointmentMap[item.doctorId].push(item);
        });
        this.data = Object.values(periodMap);
      } else {
        this.$message.error("查询失败", function () { });
      }

    },
    selectStatus(status) {
      this.statusList.forEach(item => {
        item.focus = false
      })
      status.focus = true
      this.currentStatus = status.name
    },
    showDetail(item) {
      // console.log("item", item);
      this.detailUuid = item.uuid
      this.visible2 = true

    },

  }
};
</script>